/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
import React from "react";
import PropTypes from "prop-types";

function ScrollBar({
    fillColor = "#9D9D9D",
    backColor = "#474747",
    width,
    height,
    header,
    percentage,
    setPercentage,
    windowContentsRatio,
    aframeClasses,
    ...otherAttributes
}) {
    const barHeight =
        windowContentsRatio < 1 ? height * windowContentsRatio : height;

    return (
        <a-entity class="ScrollBar" {...otherAttributes}>
            <a-plane
                class={aframeClasses}
                width={width}
                height={height}
                color={backColor}
                onClick={(e) => {
                    setPercentage(1 - e.detail.intersection.uv.y);
                }}
            >
                <a-plane
                    width={width}
                    height={barHeight}
                    color={fillColor}
                    position={`0 ${
                        height / 2 -
                        barHeight / 2 -
                        percentage * (height - barHeight)
                    } ${width / 50}`}
                />
            </a-plane>
        </a-entity>
    );
}

ScrollBar.propTypes = {
    percentage: PropTypes.number.isRequired,
    setPercentage: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
};

export default ScrollBar;
